import React from 'react'
import { Flex } from 'ui/acro'
import { css } from '@styled-system/css'
import styled from 'styled-components'
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  TikTokIcon
} from 'components_v2/Icons'

const ConnectBannerTitle = styled('p')((props) =>
  css({
    fontFamily: props.theme.fonts.Proxima,
    textTransform: 'uppercase',
    fontWeight: '300',
    fontSize: '16px',
    letterSpacing: '0.1em'
  })
)

const SocialNetworkContainer = styled(Flex)`
  &:hover {
    .social-network-link {
      fill: silver;
      :hover {
        fill: black;
      }
    }
  }
`
const SocialNetworkLink = styled('a')(() =>
  css({
    padding: '32px 16px'
  })
)

const ConnectBanner = ({ pt = '60px' }) => {
  return (
    <Flex
      justifyContent={['center']}
      alignItems={['center']}
      flexDirection={['column']}
      pt={[pt]}
      backgroundColor={'white'}
    >
      <ConnectBannerTitle>Follow us</ConnectBannerTitle>
      <SocialNetworkContainer justifyContent={['center']}>
        <SocialNetworkLink
          target='_blank'
          href='https://www.instagram.com/alomoves/?utm_medium=alomoves&utm_source=homepage&utm_campaign=bottombanner'
          className='social-network-link'
        >
          <InstagramIcon />
        </SocialNetworkLink>
        <SocialNetworkLink
          target='_blank'
          href='https://www.tiktok.com/@alomoves?utm_medium=alomoves&utm_source=homepage&utm_campaign=bottombanner'
          className='social-network-link'
        >
          <TikTokIcon />
        </SocialNetworkLink>
        <SocialNetworkLink
          target='_blank'
          href='https://www.facebook.com/alomoves?utm_medium=alomoves&utm_source=homepage&utm_campaign=bottombanner'
          className='social-network-link'
        >
          <FacebookIcon />
        </SocialNetworkLink>
      </SocialNetworkContainer>
    </Flex>
  )
}

export default ConnectBanner
